const contentHubTitles = {
    'cheltenham-festival': {
        title: 'Cheltenham festival',
        showRaceDaylive: true,
        showRegPanel: true,
    },
    'the-derby': {
        title: 'The Derby',
        showRaceDaylive: true,
        showRegPanel: true,
    },
    'grand-national': {
        title: 'Grand National',
        showRaceDaylive: true,
        showRegPanel: true,
    },
    'champions-day': {
        title: 'Champions Day',
        showRaceDaylive: true,
        showRegPanel: true,
    },
    'royal-ascot': {
        title: 'Royal Ascot',
        showRaceDaylive: true,
        showRegPanel: true,
    },
    'glorious-goodwood': {
        title: 'Glorious Goodwood',
        showRaceDaylive: true,
        showRegPanel: true,
    },
    'breeders-cup': {
        title: 'Breeders\' Cup',
        showRaceDaylive: true,
        showRegPanel: true,
    },
    '1000-guineas': {
        title: '1,000 Guineas',
        showRaceDaylive: true,
        showRegPanel: true,
    },
    '2000-guineas': {
        title: '2,000 Guineas',
        showRaceDaylive: true,
        showRegPanel: true,
    },
    'melbourne-cup': {
        title: 'Melbourne Cup',
        showRaceDaylive: true,
        showRegPanel: true,
    },
    pools: {
        title: 'Tote Pools',
        showRaceDaylive: false,
        showRegPanel: false,
    },
    'ten-to-follow': {
        title: 'Ten To Follow Competition',
        showRaceDaylive: false,
        showRegPanel: false,
    },
};

export const getNewsTitle = () => {
    const routeName = window.location.pathname.replace('/', '').replace('/', '');

    if (contentHubTitles[routeName]) {
        return contentHubTitles[routeName].title;
    }

    return '';
};

export const isContentHubPage = () => !!getNewsTitle();

export const checkForRacedayLive = () => {
    const routeName = window.location.pathname.replace('/', '').replace('/', '');

    if
    (contentHubTitles[routeName]) {
        return contentHubTitles[routeName].showRaceDaylive;
    }

    return true;
};

export const checkForRegPanel = () => {
    const routeName = window.location.pathname.replace('/', '').replace('/', '');

    if (contentHubTitles[routeName]) {
        return contentHubTitles[routeName].showRegPanel;
    }

    return true;
};

export default { isContentHubPage, getNewsTitle, checkForRacedayLive, checkForRegPanel };



// WEBPACK FOOTER //
// ./src/js/utils/contentHubHelper.js